import { takeLatest, call } from '@redux-saga/core/effects';
import { clearUserCookies } from '../../utils/cookies';
import { signOut, clearUnauthenticatedIdentity } from '../../utils/user';
import Types from '../../types';

export function* signOutUser() {
  yield call(clearUserCookies);
  yield call(clearUnauthenticatedIdentity);
  yield call(signOut);
}

export function* signOutSaga() {
  yield takeLatest(Types.SIGN_OUT, signOutUser);
}

export default signOutSaga;
